import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import HeaderView from '@/components/HeaderView.vue';
import MobileHeader from '@/components/mobile/HeaderView.vue';
import BottomNavigation from '@/components/BottomNavigation.vue';
import MobileBottomNavigation from '@/components/mobile/BottomNavigation.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter()
const store = useStore()
const hideTitle = ref(false)


const changePath = (path: string) => {
  console.log(path)
}

// 路由拦截，这里主要根据路由确定一些组件的显隐性
router.beforeEach((to, from, next) => {
  hideTitle.value = Boolean((to.meta && to.meta.hideTitle));
  const pathInfo = JSON.stringify({ query: to.query || {} })
  window.sessionStorage.setItem('path', pathInfo)
  window.localStorage.setItem('activePath', to.fullPath)
  store.state.activePath = to.fullPath;
  if (store.state.userAgent == 'mobile') {
    window.scrollTo(0, 0)
  }
  next();
});

onMounted(() => {
  setRem()
  window.addEventListener('resize', () => {
    setRem()
  }, false)
  // 判断是不是移动端
})

const setRem = () => {
  let rootDom: any = document.querySelector('html');
  let rootWidth = document.documentElement.clientWidth || document.body.clientWidth;

  var userAgent = navigator.userAgent.toLowerCase();
  if (
    userAgent.match(
      /(phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone|windows mobile|windows ce|ucweb|rv:1.2.3.4|midp)/i
    )
  ) {
    rootDom.style.fontSize = rootWidth / 750 + 'px';
    store.state.userAgent = 'mobile'
  } else {
    rootDom.style.fontSize = Math.min(Math.max(rootWidth / 1920, 1), 3) + 'px';
    store.state.userAgent = 'pc'
  }

}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(store).state.userAgent == 'pc')
      ? (_openBlock(), _createBlock(HeaderView, {
          key: 0,
          "change-path": changePath,
          hideTitle: hideTitle.value
        }, null, 8, ["hideTitle"]))
      : _createCommentVNode("", true),
    (_unref(store).state.userAgent == 'mobile')
      ? (_openBlock(), _createBlock(MobileHeader, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["router-wrap", _unref(store).state.userAgent == 'pc' ? 'web-wrap' : 'mobile-wrap'])
    }, [
      _createVNode(_component_router_view),
      (_unref(store).state.userAgent == 'pc')
        ? (_openBlock(), _createBlock(BottomNavigation, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(store).state.userAgent == 'mobile')
        ? (_openBlock(), _createBlock(MobileBottomNavigation, { key: 1 }))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})